import { Grid, H5, Input, Stack } from "@adfenix/alexandria";
import { useFormContext } from "react-hook-form";
import { ProgramService } from "@adfenix/types";
import { useDisabledFields } from "../useDisabledFields";
import { numberValidator } from "utils/react-hook-form";
import { useContext } from "react";
import { CampaignTemplateContext } from "./util/CampaignTemplateContext";
import { useTranslation } from "react-i18next";
import { formMaxWidth } from "../bundle";

export const BaseDetails = ({ children }: { children?: React.ReactNode }) => {
  const disabledFields = useDisabledFields();
  const { t } = useTranslation();
  const { register } = useFormContext<ProgramService.ProgramModel>();
  const { campaignKey } = useContext(CampaignTemplateContext);

  return (
    <Stack spacing="l">
      <H5>{t("programBuilder.program.template.custom.details.header")}</H5>
      <Grid
        columns={["1fr", "1fr 1fr 1fr"]}
        gap="l"
        style={{ maxWidth: formMaxWidth }}
      >
        <Input
          type="text"
          label={t(
            "programBuilder.program.template.custom.details.campaign.label"
          )}
          {...register(`${campaignKey}.name`, {
            required: t(
              "programBuilder.program.template.custom.details.campaign.required"
            )
          })}
          readOnly={disabledFields(
            "bundleGroups.bundles.campaignTemplates.name"
          )}
        />

        <Input
          type="text"
          label={t(
            "programBuilder.program.template.custom.details.duration.label"
          )}
          {...register(`${campaignKey}.durationDays`, {
            valueAsNumber: true,
            required: t(
              "programBuilder.program.template.custom.details.duration.required"
            ),
            validate: numberValidator("Duration")
          })}
          readOnly={disabledFields(
            "bundleGroups.bundles.campaignTemplates.durationDays"
          )}
        />

        <Input
          type="text"
          label={t(
            "programBuilder.program.template.custom.details.budget.label"
          )}
          {...register(`${campaignKey}.percentageOfTotalBudget`, {
            valueAsNumber: true,
            required: t(
              "programBuilder.program.template.custom.details.budget.required"
            ),
            validate: numberValidator("Budget")
          })}
          readOnly={disabledFields(
            "bundleGroups.bundles.campaignTemplates.budget"
          )}
        />
      </Grid>

      {children}
    </Stack>
  );
};
